module.exports = __webpack_public_path__ + "img/twitter.05a9671a.svg";